import { useGooglePlacesContext } from '../context/context';

export function useSessionToken(): {
	sessionToken: google.maps.places.AutocompleteSessionToken | undefined;
	resetSessionToken?: () => void;
} {
	const googlePlacesContext = useGooglePlacesContext();

	return {
		sessionToken: googlePlacesContext?.sessionToken,
		resetSessionToken: googlePlacesContext?.resetSessionToken,
	};
}
